import { render, staticRenderFns } from "./ScheduleCalendarSlots.vue?vue&type=template&id=55028fe0"
import script from "./ScheduleCalendarSlots.vue?vue&type=script&lang=js"
export * from "./ScheduleCalendarSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports